const Yup = require('yup');
const { dataTypes: dataTypesPrintService } = require('@common-packages/shared-constants');

const { dataTypes } = require('../constants');

const { stateOverrideValueSchema } = require('./stateOverrideValue.validation');
const dataTypeSchemaPart = require('./dataTypeSchemaPart');

const ACCOUNT_NUMBER_ERROR_MESSAGE = 'Invalid AccountNumber.';
const ROUTING_NUMBER_ERROR_MESSAGE = 'Invalid RoutingNumber.';

const accountNumberRegex = /^[A-Za-z0-9\-]{17}$/;
const routingNumberRegex = /^(01|02|03|04|05|06|07|08|09|10|11|12|21|22|23|24|25|26|27|28|29|30|31|32)[0-9]{7}$/;

const updateFormFieldsSchema = Yup.object()
  .shape({
    rows: Yup.array().of(
      Yup.object()
        .shape({
          dataType: Yup.string().required().oneOf(Object.values(dataTypes)),
          dataItemDataType: Yup.number().required().oneOf(Object.values(dataTypesPrintService)),
          description: Yup.string().nullable(),
          aliasName: Yup.string().required(),
          checkboxGroupId: Yup.string().nullable(),
          dataItemDefinitionId: Yup.string().nullable(),
          datasetDefinitionId: Yup.string().nullable(),
          datasetInstanceId: Yup.string().nullable(),
          page: Yup.number().nullable(),
          selectionListId: Yup.string().nullable(),
          sortOrder: Yup.number().nullable(),
          value: Yup.mixed().when(['dataType'], {
            is: dataType => dataType === 'CHECKBOX',
            then: stateOverrideValueSchema,
            otherwise: Yup.string()
              .nullable()
              .when(['aliasName', '$fromStateCommonInformation'], {
                is: (aliasName, fromStateCommonInformation) => {
                  return fromStateCommonInformation && aliasName === 'ACCOUNTNUMBER';
                },
                then: Yup.string().nullable().matches(accountNumberRegex, {
                  message: ACCOUNT_NUMBER_ERROR_MESSAGE,
                  excludeEmptyString: true,
                }),
                otherwise: Yup.string()
                  .nullable()
                  .when(['aliasName', '$fromStateCommonInformation'], {
                    is: (aliasName, fromStateCommonInformation) => {
                      return fromStateCommonInformation && aliasName === 'ROUTINGNUMBER';
                    },
                    then: Yup.string().nullable().matches(routingNumberRegex, {
                      message: ROUTING_NUMBER_ERROR_MESSAGE,
                      excludeEmptyString: true,
                    }),
                  }),
              }),
          }),
          context: Yup.object().nullable().shape({
            taxYear: Yup.number().nullable(),
            shortYearId: Yup.number().nullable(),
            jurisdictionId: Yup.string().nullable(),
            orgId: Yup.string().nullable(),
            consolId: Yup.string().nullable(),
            partnerId: Yup.string().nullable(),
            binderId: Yup.number().nullable(),
            jobQueueId: Yup.number().nullable(),
            requestInitiatedBy: Yup.string().nullable(),
            options: Yup.string().nullable(),
          }),
        })
        .required(),
    ),
  })
  .strict();

const updateFormFieldsSchemaConsol = Yup.object()
  .shape({
    rows: Yup.array().of(
      Yup.object()
        .shape({
          dataType: Yup.string().nullable().oneOf(Object.values(dataTypes)),
          dataItemDataType: Yup.number().required().oneOf(Object.values(dataTypesPrintService)),
          description: Yup.string().nullable(),
          aliasName: Yup.string().required(),
          checkboxGroupId: Yup.string().nullable(),
          dataItemDefinitionId: Yup.string().nullable(),
          datasetDefinitionId: Yup.string().nullable(),
          datasetInstanceId: Yup.string().nullable(),
          page: Yup.number().nullable(),
          selectionListId: Yup.string().nullable(),
          sortOrder: Yup.number().nullable(),
          value: Yup.mixed().when(['dataType'], {
            is: dataType => dataType === 'CHECKBOX',
            then: stateOverrideValueSchema,
            otherwise: Yup.string()
              .nullable()
              .when(['aliasName', '$fromStateCommonInformation'], {
                is: (aliasName, fromStateCommonInformation) => {
                  return fromStateCommonInformation && aliasName === 'ACCOUNTNUMBER';
                },
                then: Yup.string().nullable().matches(accountNumberRegex, {
                  message: ACCOUNT_NUMBER_ERROR_MESSAGE,
                  excludeEmptyString: true,
                }),
                otherwise: Yup.string()
                  .nullable()
                  .when(['aliasName', '$fromStateCommonInformation'], {
                    is: (aliasName, fromStateCommonInformation) => {
                      return fromStateCommonInformation && aliasName === 'ROUTINGNUMBER';
                    },
                    then: Yup.string().nullable().matches(routingNumberRegex, {
                      message: ROUTING_NUMBER_ERROR_MESSAGE,
                      excludeEmptyString: true,
                    }),
                  }),
              }),
          }),
          context: Yup.object().nullable().shape({
            taxYear: Yup.number().nullable(),
            shortYearId: Yup.number().nullable(),
            jurisdictionId: Yup.string().nullable(),
            orgId: Yup.string().nullable(),
            consolId: Yup.string().nullable(),
            partnerId: Yup.string().nullable(),
            binderId: Yup.number().nullable(),
            jobQueueId: Yup.number().nullable(),
            requestInitiatedBy: Yup.string().nullable(),
            options: Yup.string().nullable(),
          }),
          ...dataTypeSchemaPart,
        })
        .required(),
    ),
  })
  .strict();

module.exports = { updateFormFieldsSchema, updateFormFieldsSchemaConsol };
